<h1>Datenschutz<wbr />erklärung</h1>
<section class="article">
  <article>
    <div class="text">
      Diese Datenschutzerklärung informiert Sie darüber, in welchem Umfang und
      zu welchem Zwecke die Erhebung und Verarbeitung personenbezogener Daten
      bei der ISB Information und Kommunikation GmbH & Co. KG und innerhalb
      unseres Onlineangebotes sowie mit ihm verbundenen Webseiten, Funktionen
      und Inhalte sowie externen Onlinepräsenzen, wie z. B. unser Social Media
      Profile auf (nachfolgend gemeinsam bezeichnet als „Onlineangebot“)
      erfolgen. Im Hinblick auf die verwendeten Begrifflichkeiten, wie z. B.
      „Verarbeitung“ oder „Verantwortlicher“ verweisen wir auf die Definitionen
      im Art. 4 der Datenschutzgrundverordnung (DSGVO). Der Schutz Ihrer
      Privatsphäre ist für uns von allerhöchster Bedeutung und die Einhaltung
      der gesetzlichen Bestimmungen aus der EU-Datenschutz-Grundverordnung
      (EU-DSGVO), Bundesdatenschutzgesetzes (BDSG), Telemediengesetzes (TMG),
      ... sind für uns selbstverständlich. Ihre Informationen werden nur gemäß
      den gesetzlichen Datenschutzbestimmungen auf der Website erhoben und
      verarbeitet. Weiter haben Sie die Möglichkeit uns via E-Mail an
      datenschutz@isb-ik.de zu kontaktieren.

      <h3>Geltungsbereich und Umgang mit personenbezogenen Daten</h3>
      Die Nutzung unserer Webseite ist in der Regel ohne Angabe
      personenbezogener Daten möglich. Soweit auf unseren Seiten
      personenbezogene Daten (beispielsweise Name, Anschrift oder
      E-Mail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf
      freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung
      nicht an Dritte weitergegeben. Informationen, welche Webseite von einer
      bestimmten IP-Adresse aus abgerufen wurde oder mit welchem Browser der
      Zugriff auf die Website erfolgten, fallen nicht darunter. Wir weisen
      darauf hin, dass die Datenübertragung im Internet (z. B. bei der
      Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein
      lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht
      möglich.

      <h3>Arten der verarbeiteten Daten:</h3>
      – Bestandsdaten (z. B. Namen, Adressen). <br />
      – Kontaktdaten (z. B. E-Mail, Telefonnummern). <br />
      – Inhaltsdaten (z. B. Texteingaben, Fotografien, Videos). <br />
      – Nutzungsdaten (z. B. besuchte Webseiten, Interesse an Inhalten,
      Zugriffszeiten). <br />
      – Meta-/Kommunikationsdaten (z. B. Geräte-Informationen, IP-Adressen).

      <h3>Zweck der Verarbeitung</h3>
      – Zurverfügungstellung des Onlineangebotes, seiner Funktionen und Inhalte
      <br />
      – Beantwortung von Kontaktanfragen und Kommunikation mit Nutzern <br />
      – Reichweitenmessung/Marketing <br />
      – Nutzung von ISB Information und Kommunikation GmbH & Co.
      KG-Dienstleistungen

      <h3>Maßgebliche Rechtsgrundlagen</h3>
      Nach Maßgabe des Art. 13 DSGVO teilen wir Ihnen die Rechtsgrundlagen
      unserer Datenverarbeitungen mit. Sofern die Rechtsgrundlage in der
      Datenschutzerklärung nicht genannt wird, gilt Folgendes: Die
      Rechtsgrundlage für die Einholung von Einwilligungen ist Art. 6 Abs. 1
      lit. a und Art. 7 DSGVO, die Rechtsgrundlage für die Verarbeitung zur
      Erfüllung unserer Leistungen und Durchführung vertraglicher Maßnahmen
      sowie Beantwortung von Anfragen ist Art. 6 Abs. 1 lit. b DSGVO, die
      Rechtsgrundlage für die Verarbeitung zur Erfüllung unserer rechtlichen
      Verpflichtungen ist Art. 6 Abs. 1 lit. c DSGVO, und die Rechtsgrundlage
      für die Verarbeitung zur Wahrung unserer berechtigten Interessen ist Art.
      6 Abs. 1 lit. f DSGVO. Für den Fall, dass lebenswichtige Interessen der
      betroffenen Person oder einer anderen natürlichen Person eine Verarbeitung
      personenbezogener Daten erforderlich machen, dient Art. 6 Abs. 1 lit. d
      DSGVO als Rechtsgrundlage.

      <h3>Sicherheitsmaßnahmen</h3>
      Wir treffen nach Maßgabe des Art. 32 DSGVO unter Berücksichtigung des
      Stands der Technik, der Implementierungskosten und der Art, des Umfangs,
      der Umstände und der Zwecke der Verarbeitung sowie der unterschiedlichen
      Eintrittswahrscheinlichkeit und Schwere des Risikos für die Rechte und
      Freiheiten natürlicher Personen, geeignete technische und organisatorische
      Maßnahmen, um ein dem Risiko angemessenes Schutzniveau zu gewährleisten.
      Zu den Maßnahmen gehört insbesondere die Sicherung der Vertraulichkeit,
      Integrität und Verfügbarkeit von Daten durch Kontrolle des physischen
      Zugangs zu den Daten, als auch des sie betreffenden Zugriffs, der Eingabe,
      Weitergabe, der Sicherung der Verfügbarkeit und ihrer Trennung. Unsere
      Mitarbeiter sind auf das Datengeheimnis verpflichtet. Ebenfalls haben wir
      technische und organisatorische Maßnahmen i. S. v. Art. 24 EU-DSGVO zum
      Schutz Ihrer Daten getroffen.

      <h3>SSL- bzw. TLS-Verschlüsselung</h3>
      Diese Website nutzt zum Schutz der Übertragung vertraulicher Inhalte, eine
      SSL-bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennt man
      daran, dass die Adresszeile des Browsers von “http://” auf “https://”
      wechselt und ein Schloss-Symbol in Browserzeile erscheint. Wenn die SSL-
      bzw. TLS-Verschlüsselung aktiviert ist, können Daten, die an uns
      übermittelt werden, nicht von Dritten mitgelesen werden.

      <h3>Rechte auf Auskunft, Löschung und Widerruf von Daten</h3>
      Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung
      möglich. Nutzer haben das Recht, eine Bestätigung darüber zu verlangen, ob
      betreffende Daten verarbeitet werden und auf Auskunft über diese Daten
      sowie auf weitere Informationen und Kopie der Daten entsprechend Art. 15
      DSGVO. Zusätzlich haben die Nutzer entsprechend. Art. 16 DSGVO das Recht,
      die Vervollständigung der Sie betreffenden Daten oder die Berichtigung der
      Sie betreffenden unrichtigen Daten zu verlangen. Sie haben nach Maßgabe
      des Art. 17 DSGVO das Recht zu verlangen, dass betreffende Daten
      unverzüglich gelöscht werden, bzw. alternativ nach Maßgabe des Art. 18
      DSGVO eine Einschränkung der Verarbeitung der Daten zu verlangen. Sie
      haben das Recht zu verlangen, dass die Sie betreffenden Daten, die Sie uns
      bereitgestellt haben nach Maßgabe des Art. 20 DSGVO zu erhalten und deren
      Übermittlung an andere Verantwortliche zu fordern. Sie haben ferner gem.
      Art. 77 DSGVO das Recht, eine Beschwerde bei der zuständigen
      Aufsichtsbehörde einzureichen. Zuständige Aufsichtsbehörde in
      datenschutzrechtlichen Fragen ist der Landesdatenschutzbeauftragte des
      Bundeslandes, in dem unser Unternehmen seinen Sitz hat. Eine Liste der
      Datenschutzbeauftragten sowie deren Kontaktdaten können folgendem Link
      entnommen werden:
      <a
        href="https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html"
        >www.bfdi.bund.de/DE/Infothek/<wbr />Anschriften_Links/anschriften_links-node.html</a
      >. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen.
      Dazu reicht eine formlose Mitteilung per E-Mail an uns. Die Rechtmäßigkeit
      der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf
      unberührt. Bei Rückfragen zum Thema Datenschutz können Sie sich jederzeit
      unter der im Impressum angegebenen Adresse an uns wenden.

      <h3>Zusammenarbeit mit Auftragsverarbeitern und Dritten</h3>
      Sofern wir im Rahmen unserer Verarbeitung Daten gegenüber anderen Personen
      und Unternehmen (Auftragsverarbeitern oder Dritten) offenbaren, sie an
      diese übermitteln oder ihnen sonst Zugriff auf die Daten gewähren, erfolgt
      dies nur auf Grundlage einer gesetzlichen Erlaubnis (z. B. wenn eine
      Übermittlung der Daten an Dritte, wie an Zahlungsdienstleister, gem. Art.
      6 Abs. 1 lit. b DSGVO zur Vertragserfüllung erforderlich ist), wenn Sie
      eingewilligt haben, eine rechtliche Verpflichtung dies vorsieht oder auf
      Grundlage unserer berechtigten Interessen (z. B. beim Einsatz von
      Beauftragten, Webhostern etc.). Sofern wir Dritte mit der Verarbeitung von
      Daten auf Grundlage eines sog. „Auftragsverarbeitungsvertrages“
      beauftragen, geschieht dies auf Grundlage des Art. 28 DSGVO.

      <h3>Übermittlungen in Drittländer</h3>
      Sofern wir Daten in einem Drittland (d. h. außerhalb der Europäischen
      Union (EU) oder des Europäischen Wirtschaftsraums (EWR)) verarbeiten oder
      dies im Rahmen der Inanspruchnahme von Diensten Dritter oder Offenlegung,
      bzw. Übermittlung von Daten an Dritte geschieht, erfolgt dies nur, wenn es
      zur Erfüllung unserer (vor)vertraglichen Pflichten, auf Grundlage Ihrer
      Einwilligung, aufgrund einer rechtlichen Verpflichtung oder auf Grundlage
      unserer berechtigten Interessen geschieht. Vorbehaltlich gesetzlicher oder
      vertraglicher Erlaubnisse, verarbeiten oder lassen wir die Daten in einem
      Drittland nur beim Vorliegen der besonderen Voraussetzungen der Art. 44
      ff. DSGVO verarbeiten. D. h. die Verarbeitung erfolgt z. B. auf Grundlage
      besonderer Garantien, wie der offiziell anerkannten Feststellung eines der
      EU entsprechenden Datenschutzniveaus (z.B. für die USA durch das „Privacy
      Shield“) oder Beachtung offiziell anerkannter spezieller vertraglicher
      Verpflichtungen (so genannte „Standardvertragsklauseln“).

      <h3>Widerspruch gegen Werbe-Mails</h3>
      Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten
      Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich
      angeforderter Werbung und Informationsmaterialien wird hiermit
      ausdrücklich widersprochen. Die ISB GmbH & Co. KG behält sich ausdrücklich
      rechtliche Schritte im Falle der unverlangten Zusendung von
      Werbeinformationen, etwa durch Spam-Mails, vor.

      <h3>Cookies und Widerspruchsrecht bei Direktwerbung</h3>
      Um die Nutzerfreundlichkeit auf der Website zu verbessern, werden sog.
      Cookies verwendet. Cookies richten auf Ihrem Rechner keinen Schaden an und
      enthalten keine Viren. Sie ermöglichen Nutzern, die wiederholt die Website
      besuchen, einen leichteren Zugang. Weiter dienen Cookies dazu, unser
      Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Cookies
      sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr
      Browser speichert. Die Wiedererkennung ist möglich, weil die Cookies auch
      die IP-Adresse übermitteln. Die auf dieser Website verwendeten Cookies
      werden NICHT mit Ihren Personendaten in Verbindung gebracht. Die meisten
      der von uns verwendeten Cookies sind so genannte “Session-Cookies”. Sie
      werden nach Ende Ihres Besuchs automatisch gelöscht. Andere Cookies
      bleiben auf Ihrem Endgerät gespeichert bis Sie diese löschen. Diese
      Cookies ermöglichen es uns, Ihren Browser beim nächsten Besuch
      wiederzuerkennen. Sie als Nutzer müssen dies nicht zulassen, denn die
      Browser halten Möglichkeiten bereit, die Speicherung von Cookies
      auszuschalten oder zumindest einzuschränken. In diesem Zusammenhang ist
      darauf hinzuweisen, dass dann ggf. die Funktionalität dieser Website
      eingeschränkt sein kann und die vollumfängliche Nutzung nicht mehr gegeben
      ist. Cookies, die zur Durchführung des elektronischen
      Kommunikationsvorgangs oder zur Bereitstellung bestimmter, von Ihnen
      erwünschter Funktionen (z. B. Warenkorbfunktion) erforderlich sind, werden
      auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert. Der
      Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von
      Cookies zur technisch fehlerfreien und optimierten Bereitstellung seiner
      Dienste. Soweit andere Cookies (z. B. Cookies zur Analyse Ihres
      Surfverhaltens) gespeichert werden, werden diese in dieser
      Datenschutzerklärung gesondert behandelt. Informationen zu den am
      häufigsten verwendeten Browsern zum Einstellen der Cookie-Funktionalitäten
      finden Sie hier (Stand: 13.04.2018): Firefox®:
      support.mozilla.org/de/kb/cookies-erlauben-und-ablehnen Microsoft®:
      support.microsoft.com/de-de/help/17442/windows-internet-explorer-delete-manage-cookies
      Chrome™: support.google.com/accounts/answer/61416

      <h3>Löschung von Daten</h3>
      Die von uns verarbeiteten Daten werden nach Maßgabe der Art. 17 und 18
      DSGVO gelöscht oder in ihrer Verarbeitung eingeschränkt. Sofern nicht im
      Rahmen dieser Datenschutzerklärung ausdrücklich angegeben, werden die bei
      uns gespeicherten Daten gelöscht, sobald sie für ihre Zweckbestimmung
      nicht mehr erforderlich sind und der Löschung keine gesetzlichen
      Aufbewahrungspflichten entgegenstehen. Sofern die Daten nicht gelöscht
      werden, weil sie für andere und gesetzlich zulässige Zwecke erforderlich
      sind, wird deren Verarbeitung eingeschränkt. D. h. die Daten werden
      gesperrt und nicht für andere Zwecke verarbeitet. Das gilt z. B. für
      Daten, die aus handels- oder steuerrechtlichen Gründen aufbewahrt werden
      müssen. Nach gesetzlichen Vorgaben in Deutschland, erfolgt die
      Aufbewahrung insbesondere für 10 Jahre gemäß §§ 147 Abs. 1 AO, 257 Abs. 1
      Nr. 1 und 4, Abs. 4 HGB (Bücher, Aufzeichnungen, Lageberichte,
      Buchungsbelege, Handelsbücher, für Besteuerung relevanter Unterlagen,
      etc.) und 6 Jahre gemäß § 257 Abs. 1 Nr. 2 und 3, Abs. 4 HGB
      (Handelsbriefe). Nach gesetzlichen Vorgaben in Österreich erfolgt die
      Aufbewahrung insbesondere für 7 Jahre gemäß § 132 Abs. 1 BAO
      (Buchhaltungsunterlagen, Belege/Rechnungen, Konten, Belege,
      Geschäftspapiere, Aufstellung der Einnahmen und Ausgaben, etc.), für 10
      Jahre bei Unterlagen für die der Mini-One-Stop-Shop (MOSS) in Anspruch
      genommen wird.

      <h3>Vertragliche Leistungen</h3>
      Wir verarbeiten die Daten unserer Vertragspartner und Interessenten sowie
      anderer Auftraggeber, Kunden, Lizenznehmer oder Vertragspartner
      (einheitlich bezeichnet als „Vertragspartner“) entsprechend Art. 6 Abs. 1
      lit. b. DSGVO, um ihnen gegenüber unsere vertraglichen oder
      vorvertraglichen Leistungen zu erbringen. Die hierbei verarbeiteten Daten,
      die Art, der Umfang und der Zweck und die Erforderlichkeit ihrer
      Verarbeitung, bestimmen sich nach dem zugrundeliegenden
      Vertragsverhältnis. Zu den verarbeiteten Daten gehören die Stammdaten
      unserer Vertragspartner (z. B. Namen und Adressen), Kontaktdaten (z. B.
      E-Mail-Adressen und Telefonnummern) sowie Vertragsdaten (z. B. in Anspruch
      genommene Leistungen, Vertragsinhalte, vertragliche Kommunikation, Namen
      von Kontaktpersonen) und Zahlungsdaten (z. B. Bankverbindungen,
      Zahlungshistorie). Besondere Kategorien personenbezogener Daten
      verarbeiten wir grundsätzlich nicht, außer wenn diese Bestandteile einer
      beauftragten oder vertragsgemäßen Verarbeitung sind Wir verarbeiten Daten,
      die zur Begründung und Erfüllung der vertraglichen Leistungen erforderlich
      sind und weisen auf die Erforderlichkeit ihrer Angabe, sofern diese für
      die Vertragspartner nicht evident ist, hin. Eine Offenlegung an externe
      Personen oder Unternehmen erfolgt nur, wenn sie im Rahmen eines Vertrags
      erforderlich ist. Bei der Verarbeitung der uns im Rahmen eines Auftrags
      überlassenen Daten, handeln wir entsprechend den Weisungen der
      Auftraggeber sowie der gesetzlichen Vorgaben. Im Rahmen der
      Inanspruchnahme unserer Onlinedienste, können wir die IP-Adresse und den
      Zeitpunkt der jeweiligen Nutzerhandlung speichern. Die Speicherung erfolgt
      auf Grundlage unserer berechtigten Interessen, als auch der Interessen der
      Nutzer am Schutz vor Missbrauch und sonstiger unbefugter Nutzung. Eine
      Weitergabe dieser Daten an Dritte erfolgt grundsätzlich nicht, außer sie
      ist zur Verfolgung unserer Ansprüche gem. Art. 6 Abs. 1 lit. f. DSGVO
      erforderlich oder es besteht hierzu eine gesetzliche Verpflichtung gem.
      Art. 6 Abs. 1 lit. c. DSGVO. Die Löschung der Daten erfolgt, wenn die
      Daten zur Erfüllung vertraglicher oder gesetzlicher Fürsorgepflichten
      sowie Umgang mit etwaigen Gewährleistungs- und vergleichbaren Pflichten
      nicht mehr erforderlich ist, wobei die Erforderlichkeit der Aufbewahrung
      der Daten alle drei Jahre überprüft wird; im Übrigen gelten die
      gesetzlichen Aufbewahrungspflichten. Administration, Finanzbuchhaltung,
      Büroorganisation, Kontaktverwaltung Wir verarbeiten Daten im Rahmen von
      Verwaltungsaufgaben sowie Organisation unseres Betriebs, Finanzbuchhaltung
      und Befolgung der gesetzlichen Pflichten, wie z. B. der Archivierung.
      Hierbei verarbeiten wir dieselben Daten, die wir im Rahmen der Erbringung
      unserer vertraglichen Leistungen verarbeiten. Die Verarbeitungsgrundlagen
      sind Art. 6 Abs. 1 lit. c. DSGVO, Art. 6 Abs. 1 lit. f. DSGVO. Von der
      Verarbeitung sind Kunden, Interessenten, Geschäftspartner und
      Websitebesucher betroffen. Der Zweck und unser Interesse an der
      Verarbeitung liegt in der Administration, Finanzbuchhaltung,
      Büroorganisation, Archivierung von Daten, also Aufgaben die der
      Aufrechterhaltung unserer Geschäftstätigkeiten, Wahrnehmung unserer
      Aufgaben und Erbringung unserer Leistungen dienen. Die Löschung der Daten
      im Hinblick auf vertragliche Leistungen und die vertragliche Kommunikation
      entspricht den, bei diesen Verarbeitungstätigkeiten genannten Angaben. Wir
      offenbaren oder übermitteln hierbei Daten an die Finanzverwaltung,
      Berater, wie z. B., Steuerberater oder Wirtschaftsprüfer sowie weitere
      Gebührenstellen und Zahlungsdienstleister. Ferner speichern wir auf
      Grundlage unserer betriebswirtschaftlichen Interessen Angaben zu
      Lieferanten, Veranstaltern und sonstigen Geschäftspartnern, z. B. zwecks
      späterer Kontaktaufnahme. Diese mehrheitlich unternehmensbezogenen Daten,
      speichern wir grundsätzlich dauerhaft.

      <h3>Kontaktaufnahme</h3>
      Bei der Kontaktaufnahme mit uns (z. B. per Kontaktformular, E-Mail,
      Telefon oder via sozialer Medien) werden die Angaben des Nutzers zur
      Bearbeitung der Kontaktanfrage und deren Abwicklung gem. Art. 6 Abs. 1
      lit. b) DSGVO verarbeitet. Die Angaben der Nutzer können in einem
      Customer-Relationship-Management System („CRM System“) oder vergleichbarer
      Anfragenorganisation gespeichert werden. Wir löschen die Anfragen, sofern
      diese nicht mehr erforderlich sind. Wir überprüfen dies regelmäßig; Ferner
      gelten die gesetzlichen Archivierungspflichten.

      <h3>Hinweise zum Newsletter und Einwilligungen</h3>
      Mit den nachfolgenden Hinweisen klären wir Sie über die Inhalte unseres
      Newsletters sowie das Anmelde-, Versand- und das statistische
      Auswertungsverfahren sowie Ihre Widerspruchsrechte auf. Indem Sie unseren
      Newsletter abonnieren, erklären Sie sich mit dem Empfang und den
      beschriebenen Verfahren einverstanden. Inhalt des Newsletters Wir
      versenden Newsletter, E-Mails und weitere elektronische Benachrichtigungen
      mit werblichen Informationen (nachfolgend „Newsletter“) nur mit der
      Einwilligung der Empfänger oder einer gesetzlichen Erlaubnis. Sofern im
      Rahmen einer Anmeldung zum Newsletter dessen Inhalte konkret umschrieben
      werden, sind sie für die Einwilligung der Nutzer maßgeblich. Im Übrigen
      enthalten unsere Newsletter Informationen und Dienstleistungen der ISB
      GmbH & Co. KG. Hinzu kommen Neuigkeiten und Unternehmensnachrichten sowie
      Hinweise auf Blogbeiträge, Vorträge oder Workshops.

      <h3>Anmeldedaten</h3>
      Um sich für den Newsletter anzumelden reicht es aus, wenn Sie Ihre
      E-Mailadresse und zwecks persönlicher Ansprache im Newsletters die Anrede,
      Vor- und Nachname angeben. Double-Opt-In und Protokollierung Die Anmeldung
      zu unserem Newsletter erfolgt in einem sog. Double-Opt-In-Verfahren. D. h.
      Sie erhalten nach der Anmeldung eine E-Mail, in der Sie um die Bestätigung
      Ihrer Anmeldung gebeten werden. Diese Bestätigung ist notwendig, damit
      sich niemand mit fremden E-Mailadressen anmelden kann. Die Anmeldungen zum
      Newsletter werden protokolliert, um den Anmeldeprozess entsprechend den
      rechtlichen Anforderungen nachweisen zu können. Hierzu gehört die
      Speicherung des Anmelde- und des Bestätigungszeitpunkts, als auch der
      IP-Adresse.

      <h3>Kündigung/Widerruf des Newsletters</h3>
      Sie können dem Empfang unseres Newsletters jederzeit kündigen, d. h. Ihre
      Einwilligungen widerrufen. Damit erlöschen gleichzeitig Ihre
      Einwilligungen in dessen Versand via RapidMail und die statistischen
      Analysen. Ein getrennter Widerruf des Versandes via RapidMail oder der
      statistischen Auswertung ist leider nicht möglich. Einen Link zur
      Kündigung des Newsletters finden Sie am Ende eines jeden Newsletters. Der
      Versand der ISB Iinformation und Kommunikation GmbH & CO. KG Newsletter
      erfolgt mittels RapidMail, einer Newsletterversandplattform mit Sitz in
      Freiburg, Deutschland. Die Datenschutzbestimmungen des
      Versanddienstleisters können Sie hier einsehen:
      www.rapidmail.de/datenschutz Statistische Erhebung und Analysen Die
      Newsletter enthalten einen sog. „web-beacon“, d. h. eine pixelgroße Datei,
      die beim Öffnen des Newsletters von dem Server von RapidMail abgerufen
      wird. Im Rahmen dieses Abrufs werden zunächst technische Informationen,
      wie Informationen zum Browser und Ihrem System, als auch Ihre IP-Adresse
      und Zeitpunkt des Abrufs erhoben. Dies Informationen werden zur
      technischen Verbesserung der Services, anhand von technischen Daten oder
      von Zielgruppen und Ihr Leseverhalten anhand der Abruforte (die mit Hilfe
      der IP-Adresse bestimmbar sind) oder der Zugriffszeiten verwendet. Zu den
      statistischen Erhebungen gehört ebenfalls die Feststellung, ob die
      Newsletter geöffnet werden, wann sie geöffnet werden und welche Links
      geklickt werden. Diese Informationen können aus technischen Gründen zwar
      den einzelnen Newsletterempfängern zugeordnet werden. Es ist jedoch weder
      unser Bestreben, noch das von RapidMail, einzelne Nutzer zu beobachten.
      Die Auswertungen dienen uns viel mehr dazu, die Lesegewohnheiten unserer
      Nutzer zu erkennen und unsere Inhalte auf sie anzupassen oder
      unterschiedliche Inhalte entsprechend den Interessen unserer Nutzer zu
      versenden.

      <h3>Website Hosting</h3>
      Die von uns in Anspruch genommenen Hosting-Leistungen dienen der
      Zurverfügungstellung der folgenden Leistungen: Infrastruktur- und
      Plattformdienstleistungen, Rechenkapazität, Speicherplatz und
      Datenbankdienste, Sicherheitsleistungen sowie technische
      Wartungsleistungen, die wir zum Zwecke des Betriebs dieses Onlineangebotes
      einsetzen. Hierbei verarbeiten wir, bzw. unser Hostinganbieter
      Bestandsdaten, Kontaktdaten, Inhaltsdaten, Vertragsdaten, Nutzungsdaten,
      Meta- und Kommunikationsdaten von Kunden, Interessenten und Besuchern
      dieses Onlineangebotes auf Grundlage unserer berechtigten Interessen an
      einer effizienten und sicheren Zurverfügungstellung dieses Onlineangebotes
      gem. Art. 6 Abs. 1 lit. f DSGVO i.V.m. Art. 28 DSGVO (Abschluss
      Auftragsverarbeitungsvertrag). Erhebung von Zugriffsdaten und Logfiles
      Wir, bzw. unser Hostinganbieter, erhebt auf Grundlage unserer berechtigten
      Interessen im Sinne des Art. 6 Abs. 1 lit. f. DSGVO Daten über jeden
      Zugriff auf den Server, auf dem sich dieser Dienst befindet (sogenannte
      Serverlogfiles). Zu den Zugriffsdaten gehören Name der abgerufenen
      Webseite, Datei, Datum und Uhrzeit des Abrufs, übertragene Datenmenge,
      Meldung über erfolgreichen Abruf, Browsertyp nebst Version, das
      Betriebssystem des Nutzers, Referrer URL (die zuvor besuchte Seite),
      IP-Adresse und der anfragende Provider. Logfile-Informationen werden aus
      Sicherheitsgründen (z. B. zur Aufklärung von Missbrauchs- oder
      Betrugshandlungen) für die Dauer von maximal 7 Tagen gespeichert und
      danach gelöscht. Daten, deren weitere Aufbewahrung zu Beweiszwecken
      erforderlich ist, sind bis zur endgültigen Klärung des jeweiligen Vorfalls
      von der Löschung ausgenommen.

      <h3>Google Analytics</h3>
      Wir setzen auf Grundlage unserer berechtigten Interessen (d. h. Interesse
      an der Analyse, Optimierung und wirtschaftlichem Betrieb unseres
      Onlineangebotes im Sinne des Art. 6 Abs. 1 lit. f. DSGVO) Google
      Analytics, einen Webanalysedienst der Google LLC („Google“) ein. Google
      Analytics verwendet sog. "Cookies", Textdateien, die auf Ihrem Computer
      gespeichert werden und die eine Analyse der Benutzung der Website
      ermöglichen. Die durch das Cookie erzeugten Informationen über die
      Benutzung des Onlineangebotes durch die Nutzer werden in der Regel an
      einen Server von Google in den USA übertragen und dort gespeichert. Google
      ist unter dem Privacy-Shield-Abkommen zertifiziert und bietet hierdurch
      eine Garantie, das europäische Datenschutzrecht einzuhalten (<a
        href="https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active"
        target="_blank"
        >https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active</a
      >) . Google wird diese Informationen in unserem Auftrag benutzen, um die
      Nutzung unseres Onlineangebotes durch die Nutzer auszuwerten, um Reports
      über die Aktivitäten innerhalb dieses Onlineangebotes zusammenzustellen
      und um weitere mit der Nutzung dieses Onlineangebotes und der
      Internetnutzung verbundene Dienstleistungen uns gegenüber zu erbringen.
      Dabei können aus den verarbeiteten Daten pseudonyme Nutzungsprofile der
      Nutzer erstellt werden. ISB GmbH & Co. KG setzt Google Analytics nur mit
      aktivierter IP-Anonymisierung ein. Das bedeutet, die IP-Adresse der Nutzer
      wird von Google innerhalb von Mitgliedstaaten der Europäischen Union oder
      in anderen Vertragsstaaten des Abkommens über den Europäischen
      Wirtschaftsraum gekürzt. Nur in Ausnahmefällen wird die volle IP-Adresse
      an einen Server von Google in den USA übertragen und dort gekürzt. Die von
      dem Browser des Nutzers übermittelte IP-Adresse wird nicht mit anderen
      Daten von Google zusammengeführt. Die Nutzer können die Speicherung der
      Cookies durch eine entsprechende Einstellung ihrer Browser-Software
      verhindern; die Nutzer können darüber hinaus die Erfassung der durch das
      Cookie erzeugten und auf ihre Nutzung des Onlineangebotes bezogenen Daten
      an Google sowie die Verarbeitung dieser Daten durch Google verhindern,
      indem sie das unter dem folgenden Link verfügbare Browser-Plugin
      herunterladen und installieren: tools.google.com/dlpage/gaoptout . Die
      personenbezogenen Daten der Nutzer werden nach 14 Monaten gelöscht oder
      anonymisiert. Weitere Informationen zur Datennutzung durch Google,
      Einstellungs- und Widerspruchsmöglichkeiten, erfahren Sie in der
      Datenschutzerklärung von Google (<a
        href="https://policies.google.com/technologies/ads"
        target="_blank"
        >https://policies.google.com/technologies/ads</a
      >) sowie in den Einstellungen für die Darstellung von Werbeeinblendungen
      durch Google (<a
        href="https://adssettings.google.com/authenticated"
        target="_blank"
        >https://adssettings.google.com/authenticated</a
      >).

      <h3>Google Maps</h3>
      ISB GmbH & Co. KG setzt die Landkarten von Google Maps, des Anbieters
      Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA, ein.
      Die Daten können in den USA verarbeitet werden. Zu den verarbeiteten Daten
      können insbesondere IP-Adressen und Standortdaten der Nutzer gehören, die
      jedoch nicht ohne deren Einwilligung (im Regelfall im Rahmen der
      Einstellungen ihrer Mobilgeräte vollzogen), erhoben werden.

      <h3>Google Fonts</h3>
      ISB GmbH & Co. KG bindet auf der Website video2manual.de Schriftarten/
      Google Fonts, ein Dienst der Google Inc. ("Google") ein. Die Einbindung
      dieser Web Fonts erfolgt durch einen Serveraufruf, in der Regel ein Server
      von Google in den USA. Hierdurch wird an den Server übermittelt, welche
      unserer Internetseiten Sie besucht haben. Auch wird die IP-Adresse des
      Browsers des Endgerätes des Besuchers dieser Internetseiten von Google
      gespeichert. Weitere Informationen zur Datennutzung, den
      Nutzungsbedingungen, zu Werbezwecken durch Google, Einstellungs- und
      Widerspruchsmöglichkeiten erfahren Sie auf den Webseiten von Google:<br />
      Datenschutzerklärung & Nutzungsbedingungen von Google<br />
      <a href="https://www.google.com/policies/privacy/" target="_blank"
        >www.google.com/policies/privacy/</a
      ><br />
      Opt-Out<br />
      <a href="https://adssettings.google.com/authenticated" target="_blank"
        >adssettings.google.com/authenticated</a
      ><br />
      Datennutzung durch Google bei Ihrer Nutzung von Websites oder Apps unserer
      Partner<br />
      <a
        href="https://www.google.com/intl/de/policies/privacy/partners/"
        target="_blank"
        >www.google.com/intl/de/policies/privacy/partners/</a
      ><br />
      Datennutzung zu Werbezwecken<br />
      <a href="https://www.google.com/policies/technologies/ads" target="_blank"
        >www.google.com/policies/technologies/ads</a
      ><br />
      Informationen verwalten, die Google verwendet, um Ihnen Werbung
      einzublenden Bestimmen Sie, welche Werbung Google Ihnen zeigt<br />
      <a href="https://www.google.com/ads/preferences/" target="_blank"
        >www.google.com/ads/preferences/</a
      >
      <br />
      Google APIs Terms of Service <br />
      <a href="https://developers.google.com/terms/" target="_blank"
        >developers.google.com/terms/</a
      >

      <h3>Übrige Einbindung von Diensten und Inhalten Dritter</h3>
      Diese Website bindet gelegentlich auch Inhalte Dritter, wie zum Beispiel
      Videos von YouTube, Kartenmaterial von Google Maps, RSS-Feeds oder
      Grafiken von anderen Webseiten ein. Dies setzt immer voraus, dass die
      Anbieter dieser Inhalte (nachfolgend bezeichnet als „Dritt-Anbieter“) die
      IP-Adresse der Nutzer wahrnehmen. Ohne die IP-Adresse, könnten sie die
      Inhalte nicht an den Browser des jeweiligen Nutzers senden. Die IP-Adresse
      ist damit für die Darstellung dieser Inhalte erforderlich. Wir bemühen uns
      nur solche Inhalte zu verwenden, deren jeweilige Anbieter die IP-Adresse
      lediglich zur Auslieferung der Inhalte verwenden. Jedoch haben wir keinen
      Einfluss darauf, falls die Dritt-Anbieter die IP-Adresse z.B. für
      statistische Zwecke speichern. Soweit dies uns bekannt ist, klären wir die
      Nutzer darüber auf.

      <h3>Änderungen der Datenschutzerklärung</h3>
      Wir behalten uns vor, die Datenschutzerklärung zu ändern, um sie an
      geänderte Rechtslagen, oder bei Änderungen des Dienstes sowie der
      Datenverarbeitung anzupassen. Dies gilt jedoch nur im Hinblick auf
      Erklärungen zur Datenverarbeitung. Sofern Einwilligungen der Nutzer
      erforderlich sind oder Bestandteile der Datenschutzerklärung Regelungen
      des Vertragsverhältnisses mit den Nutzern enthalten, erfolgen die
      Änderungen nur mit Zustimmung der Nutzer. Die Nutzer werden gebeten sich
      regelmäßig über den Inhalt der Datenschutzerklärung zu informieren.

      <h3>Weitere Hinweise</h3>
      Die ISB GmbH & Co. KG ist bemüht, Ihre personenbezogenen Daten durch
      Ergreifung aller technischen und organisatorischen Möglichkeiten so zu
      speichern, dass sie für Dritte nicht zugänglich sind. Bei der
      Kommunikation per E-Mail kann die vollständige Datensicherheit nicht
      gewährleistet werden, so dass wir Ihnen bei vertraulichen Informationen
      den Postweg empfehlen. Die Mitarbeiter und die von der ISB GmbH & Co. KG
      beauftragten Dienstleistungsunternehmen sind von der ISB GmbH & Co. KG zur
      Verschwiegenheit und zur Einhaltung der Bestimmungen des
      Bundesdatenschutzgesetzes und sonstiger berufsbezogener
      Datenschutzbestimmungen verpflichtet.

      <h3>Hinweise zu den Markennamen</h3>
      Bei den Bezeichnungen Firefox®, Microsoft® und Chrome™ handelt es sich um
      geschützte Bezeichnungen (Markennamen, Trademarks, ...) der jeweiligen
      Hersteller. Details entnehmen Sie bitte den zugehörigen Websites der
      Hersteller: www.mozilla.org , www.microsoft.de und/oder www.google.de.

      <h3>Quellen</h3>
      Hinweise zur Datenschutzerklärung nach Mustern von Rechtsanwalt Dr. Thomas
      Schwenke, datenschutzbeaufrtragter-info.de und eRecht24.
    </div>
  </article>
</section>
